/**
* Custom Select
*/
class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom-dropdown');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', ()=> {
      Utility.toggleElement(this.selectContainer, 'close')
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    _this.closest('.custom-dropdown').classList.add('selected');
    Utility.toggleElement(this.selectContainer, 'close');
    setTimeout(() => {
      if(_this.querySelector('.option_txt') != null)
        this.initOption.querySelector('.option_txt').textContent = _this.querySelector('.option_txt').textContent;
    }, 500);
  }

  /**
   * Hide/Show of custom select option
   * @param _event 
   */
    manageVisibility(_event){
      let isOpen = this.selectContainer.classList.contains('open');
      isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
    }
}
customElements.define('custom-select', customSelect);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
}
customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if (!this.toggleBtn) return;
    this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
    if (this.toggleBtn.getAttribute('role') === 'button' && this.toggleBtn.tagName !== 'BUTTON') {
      this.toggleBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.togglePanel();
        }
      });
    }
  }

  togglePanel() {
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    if (event.target.closest('[data-modal-opener]')) return;
    if (event.target.closest('#installCheck')) return;
    const innerLink = event.target.closest('a[href]');
    if (innerLink && innerLink !== this.toggleBtn && this.toggleBtn.contains(innerLink)) return;
    if (this.toggleBtn.tagName === 'A') event.preventDefault();
    this.togglePanel();
  }

  /**
   * @param {{ isInitialBatch?: boolean }} [options] - When isInitialBatch, skips focus trap and single-accordion sibling closing (used on page load).
   */
  showContent(options = {}) {
    const isInitialBatch = options.isInitialBatch === true;
    this.toggleBtn.setAttribute('aria-expanded', 'true');
    Utility.toggleElement(this.element, 'open');
    if (!isInitialBatch) {
      Utility.trapFocus(this.element);
    }

    if (this.element.dataset.behaviour == 'single' && !isInitialBatch) {
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach((element) => {
        if (element == this.element) return;
        const btn = element.querySelector('.panel_toggle');
        if (btn) btn.click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    const openOnLoad = [];
    collapsibleElements.forEach((ele) => {
      if (
        ele.hasAttribute('data-variant-installation-root') ||
        ele.hasAttribute('data-variant-stains-root') ||
        (ele.hasAttribute('data-meridian-collapsible') &&
          ele.closest('[data-product-container].template-meridian-gazebo-bundle'))
      ) {
        return;
      }
      const panel = new collapsiblePanel(ele);
      if (
        panel.toggleBtn &&
        ele.classList.contains('collapsible_panel') &&
        ele.dataset.startClosed !== 'true'
      ) {
        openOnLoad.push(panel);
      }
    });
    openOnLoad.forEach((panel) => panel.showContent({ isInitialBatch: true }));
  }
}
collapsiblePanel.init();
  

  
  
